import styled from 'styled-components';
import { PriceRow } from '..';
import {
  StoreLogo,
  DEFAULT_STORE_LOGO_MAX_WIDTH,
} from 'src/components/store-logo/styles';

export const StyledOurChoicePriceRow = styled(PriceRow)`
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.12);

  ${StoreLogo} {
    max-width: ${DEFAULT_STORE_LOGO_MAX_WIDTH}px;
  }
`;
